import React from 'react';
import Navbar from '../components/Navbar';
import './Privacy.css';

function Privacy() {
    return (
        <div className="page-container privacy-page">
            <Navbar />

            <section className="privacy-hero">
                <div className="container">
                    <div className="privacy-hero-content">
                        <span className="section-badge">INFORMACIÓN LEGAL</span>
                        <h1 className="privacy-title">
                            Política de <span className="gradient-text">Privacidad</span>
                        </h1>
                        <p className="privacy-subtitle">
                            Última actualización: 19 de marzo de 2026
                        </p>
                    </div>
                </div>
            </section>

            <section className="privacy-content">
                <div className="container">
                    <div className="privacy-wrapper">
                        <div className="privacy-section">
                            <p>
                                Esta política de privacidad (en adelante, la "Política") establece la forma en que la plataforma recopila, utiliza, almacena y divulga información sobre los usuarios.
                                También describe las prácticas que aplicamos a dicha información, sus derechos de privacidad y las opciones de elección con respecto a sus datos.
                                Para mayor claridad, esta Política se aplica a todos los usuarios de la plataforma (en adelante, "Estudiantes", "Usted").
                            </p>
                            <p>
                                Al acceder y utilizar la plataforma, proporcionar sus datos personales o expresar su consentimiento cuando se le ofrece una opción, usted acepta la recopilación, el uso y la divulgación de información de acuerdo con esta Política y los Términos de uso. No asumimos ninguna responsabilidad derivada de sus acciones.
                                Si no está de acuerdo con alguna disposición de esta Política y/o de los Términos de uso, absténgase de acceder a la plataforma y utilizar sus servicios y abandónela de inmediato.
                                Si la información que proporciona infringe los términos de esta Política o de los Términos de uso, podemos eliminarla y restringir su acceso a la plataforma sin previo aviso ni responsabilidad ante usted.
                                Los términos utilizados en esta Política que no estén definidos deben interpretarse de acuerdo con nuestros Términos de uso.
                                Lea atentamente la Política antes de utilizar nuestros servicios. En caso de dudas, póngase en contacto con nosotros a través de los medios indicados.
                            </p>
                        </div>

                        <div className="privacy-section">
                            <h2>Información Personal</h2>
                            <p>
                                "Información personal" significa datos que identifican al Estudiante, como nombre y apellido, número de identificación, dirección de correo electrónico, edad, género, ubicación, fotografías y/o número de teléfono proporcionados durante el registro o posteriormente.
                            </p>
                            <p>
                                "Información personal confidencial" incluye: (i) contraseñas y datos financieros (excepto los últimos 4 dígitos de las tarjetas), (ii) datos de salud, (iii) identificadores gubernamentales (biometría, identificación fiscal, datos de pasaporte), (iv) datos sobre orientación sexual, raza, creencias políticas o religiosas, (v) detalles de la cuenta, o (vi) cualquier dato clasificado como "categorías especiales de datos" según el GDPR, CCPA u otras leyes de protección de datos aplicables.
                            </p>
                            <p>
                                El uso del término "Información personal" incluye "Información personal confidencial" cuando sea aplicable según el contexto.
                            </p>
                        </div>

                        <div className="privacy-section">
                            <h2>Información que Recopilamos</h2>
                            <p>
                                Podemos recopilar información tanto personal como no personal de diversas formas, incluyendo la visita a la plataforma, el registro y otras actividades relacionadas con nuestros servicios. Tenga en cuenta lo siguiente:
                            </p>
                            <ul>
                                <li>No solicitamos información personal a menos que sea realmente necesaria (por ejemplo, para el registro).</li>
                                <li>No compartimos su información personal con terceros, excepto en los casos de cumplimiento de la ley, desarrollo de productos o protección de nuestros derechos.</li>
                                <li>Almacenamos información personal en servidores solo el tiempo necesario para el funcionamiento de la plataforma.</li>
                                <li>Para cargar contenido de usuario se utiliza https://spayeeservers1.com.</li>
                            </ul>

                            <p><strong>Información de identificación personal:</strong> Podemos recopilar dicha información (nombre, correo electrónico) solo si la proporciona voluntariamente. Puede negarse, pero esto puede limitar el acceso a algunas funciones de la plataforma.</p>

                            <p><strong>Información no personal:</strong> Al utilizar la plataforma, podemos recopilar datos técnicos: nombre del navegador, configuración de idioma, tipo de sistema operativo, proveedor de servicios de Internet y otros datos similares.</p>

                            <p><strong>Cookies:</strong> Nuestra plataforma puede utilizar cookies para mejorar la experiencia del usuario. Puede desactivarlas en la configuración de su navegador, pero esto puede afectar el funcionamiento correcto de algunas partes del sitio.</p>
                        </div>

                        <div className="privacy-section">
                            <h2>Cómo Utilizamos y Compartimos la Información</h2>
                            <p>Utilizamos la información para los siguientes fines:</p>
                            <ul>
                                <li><strong>Para proporcionar acceso:</strong> Para atención al cliente, procesamiento de compras, verificación de datos y resolución de problemas técnicos en la plataforma.</li>
                                <li><strong>Para mejora y seguridad:</strong> Para analizar el uso del sitio, configurar la personalización y prevenir el fraude o el abuso de la red.</li>
                                <li><strong>Para comunicación y marketing:</strong> Podemos utilizar su correo electrónico para notificaciones de pedidos, noticias, nuevos productos o para recibir comentarios.</li>
                            </ul>
                            <p>No vendemos ni intercambiamos su información personal. Podemos compartir datos demográficos agregados generales, no vinculados a personas específicas, con nuestros socios para los fines indicados anteriormente.</p>
                        </div>

                        <div className="privacy-section">
                            <h2>Sus Derechos</h2>
                            <p>Todos los Estudiantes tienen los siguientes derechos:</p>
                            <ul>
                                <li><strong>Derecho de acceso:</strong> Puede solicitar la confirmación y el acceso a sus datos personales que almacenamos.</li>
                                <li><strong>Derecho de rectificación:</strong> Puede exigir la corrección de datos personales inexactos.</li>
                                <li><strong>Derecho al olvido:</strong> En ciertas circunstancias, puede restringir la divulgación posterior de sus datos.</li>
                                <li><strong>Derecho de supresión:</strong> Puede solicitar la eliminación completa de su información personal de nuestro sistema.</li>
                            </ul>
                        </div>

                        <div className="privacy-section">
                            <h2>Transferencia Transfronteriza de Datos</h2>
                            <p>
                                Su información puede almacenarse y procesarse en servidores y bases de datos de Amazon Web Service (AWS) ubicados en la India, así como en otros países, dependiendo de la ubicación de nuestros socios y proveedores de servicios.
                            </p>
                        </div>

                        <div className="privacy-section">
                            <h2>Reclamaciones y Contacto</h2>
                            <p>
                                Si tiene preguntas sobre esta Política, desea ejercer sus derechos o tiene quejas, póngase en contacto con nosotros por correo electrónico: <a href="mailto:support@talktokrishna.ai">support@talktokrishna.ai</a>.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Privacy;

